export default __webpack_public_path__ + "static/media/toybox.39686371.png";